import { styled, Box, BoxProps, Typography, TypographyProps, StackProps, Stack } from '@mui/material'
import { ComponentType } from 'react'

export const LoadingContainer: ComponentType<BoxProps> = styled( Box )( {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '100%',
} )


export const StyledBox: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	maxWidth: theme.spacing( 75 ),
	marginTop: theme.spacing( 2 ),
} ) )


export const StyledIntegrationTypography: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	maxWidth: '800px',
	marginBottom: theme.spacing( 4 ),
} ) )

export const FormInputSection: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	paddingBottom: theme.spacing( 2 ),
} ) )

export const FeedDescriptionSection: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	marginBottom: theme.spacing( 3 ),
} ) )
